module.exports = __webpack_public_path__ + "img/موز-صورة.5586fc62.png";